const initialState = {
    user: {
        uid: '',
        email: '',
        role: ''
    }
}

const CurrentUser = (state = initialState, action: any) => {
    switch (action.type) {
        case "SET_USER":
            return {
                ...state,
                user: action.payload
            };
        default:
            return state;
    }
};

export default CurrentUser;